import { Cell } from '@/design_system/Table/Table';
import { ShipmentWithRelations } from '@/models/shipment';

import { ShipmentDestination } from '../../ShipmentDestination';

export const ShipmentDestinationCell = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  return (
    <Cell>
      <ShipmentDestination shipment={shipment} />
    </Cell>
  );
};
